<script setup lang="ts">
import { RouterView } from 'vue-router'

import { zhTw } from 'element-plus/es/locales.mjs'

import GlobalDialog from '@/components/global/GlobalDialog.vue'
</script>

<template>
  <el-config-provider :locale="zhTw">
    <RouterView />
    <GlobalDialog />
  </el-config-provider>
</template>
